module.exports = __webpack_public_path__ + "img/main.01f85c67.jpg";